import { ControlFacet } from '../models/controls/ControlFacet';

/**
 * Control to override the items seen as selected within an items scope.
 */
export const selectedItemsControl: ControlFacet<{
  itemsScopeItemKey: string;
}, {
    itemKeys: string[];
  }> = new ControlFacet('selectedItems');
